/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';
import store from 'store';
import { useDispatch } from 'react-redux';

import TempLayout from 'pages/_layouts/temporary';
import AuthLayout from '../pages/_layouts/auth';
import DefaultLayout from '../pages/_layouts/default';
import AuthActions from 'store/ducks/auth';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  ...rest
}) {
  const dispatch = useDispatch()
  const { pathname } = useLocation();
  const { signedIn, userActive } = store.getState().auth;

  // Mover o dispatch para useEffect para evitar atualização durante render
  useEffect(() => {
    // SEMPRE verificar apenas se está autenticado (não usar mais profile - campo descontinuado)
    if (isPrivate && !signedIn) {
      dispatch(AuthActions.signOut());
    }
  }, [isPrivate, signedIn, userActive, dispatch]);

  if (!Component) {
    console.warn('RouteWrapper: component prop is required');
    return null;
  }

  // SEMPRE verificar apenas se está autenticado (não usar mais profile - campo descontinuado)
  if (isPrivate && !signedIn) {
    return <Redirect to="/" />;
  }

  // Permitir acesso a rotas públicas específicas mesmo se autenticado (como iniciar-viagem, temp, rate)
  const isPublicRouteAllowed = pathname.split('/')[1] === 'temp' || 
                                pathname.split('/')[1] === 'rate' || 
                                pathname.split('/')[1] === 'iniciar-viagem';
  
  if (signedIn && !isPrivate && !isPublicRouteAllowed) {
    return <Redirect to="/dashboard" />;
  }

  // eslint-disable-next-line no-nested-ternary
  const Layout = signedIn
    ? DefaultLayout
    : pathname.split('/')[1] === 'temp' || pathname.split('/')[1] === 'rate' || pathname.split('/')[1] === 'iniciar-viagem'
      ? TempLayout
      : AuthLayout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout rate={pathname.split('/')[1] === 'rate'}>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.elementType,
  ]).isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
